import script from "./selfCard.vue?vue&type=script&setup=true&lang=js"
export * from "./selfCard.vue?vue&type=script&setup=true&lang=js"

import "./selfCard.vue?vue&type=style&index=0&id=e435de4e&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e435de4e"]])

export default __exports__